import { DescriptionFormatter, StartChatWidget, TitleFormatter } from '@cian/start-chat-widget';
import * as React from 'react';
import * as Modal from 'react-modal';
import { connect } from 'react-redux';
import * as PropTypes from 'prop-types';

import { IAgentAvailabilitySchema, IOfferSchema, IUserSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { IContext, IState } from '../../../store';

import { sendSystemPushNotificationPopup } from '../../../utils/flocktory';

import * as styles from './index.css';
import { DEFAULT_CHAT_MESSAGE } from '../../../constants/text';
import { IHttpApi } from '@cian/http-api';
import { IFirstMessage } from '@cian/start-chat-widget/lib/shared/types';
import { sendFirstMessage } from '../../../api/chats';

export interface IPopupCallbackStoreProps {
  offer: IOfferSchema;
  user: IUserSchema | null;
  agentAvailability: IAgentAvailabilitySchema | null;
  captchaSpamSiteKey: string;
  pushSubscribed: boolean;
}

export interface IPopupCallbackOwnProps {
  isOpen: boolean;
  message?: string;

  onMessageChange(value: string): void;
  onMessageSent(chatId: string): void;
  onClose(): void;
}

export type IPopupStartChatProps = IPopupCallbackStoreProps & IPopupCallbackOwnProps;

class PopupStartChatComponent extends React.Component<IPopupStartChatProps, {}> {
  public context: IContext;

  public static contextTypes = {
    chatsHttpConfig: PropTypes.object,
    httpApi: PropTypes.object,
  };

  public render() {
    const {
      isOpen,
      message,
      onMessageChange,
      onMessageSent,
      onClose,
      offer,
      user,
      agentAvailability,
      captchaSpamSiteKey,
      pushSubscribed,
    } = this.props;

    const phone = user && user.phones && user.phones.length > 0 ? user.phones.find(p => !!p.phone) : undefined;

    const phones =
      offer && offer.phones && offer.phones.length > 0 ? offer.phones.map(p => `${p.countryCode}${p.number}`) : null;

    const isNotAvailable = !agentAvailability || !agentAvailability.available;

    return (
      <Modal
        isOpen={isOpen}
        ariaHideApp={false}
        onRequestClose={onClose}
        style={{
          content: {
            overflow: 'visible',
            padding: '0',
            position: 'static',
            width: '500px',
            zIndex: 101,
          },
          overlay: {
            alignItems: 'center',
            backgroundColor: 'rgba(24, 41, 48, .8)',
            display: 'flex',
            justifyContent: 'center',
            zIndex: 100,
          },
        }}
      >
        <StartChatWidget
          offerId={offer.id}
          sendFirstMessage={startChat(this.context.httpApi)}
          userEmail={(user && user.email) || undefined}
          userPhone={(phone && phone.phone) || undefined}
          initialMessage={message || DEFAULT_CHAT_MESSAGE}
          onClose={onClose}
          onMessageChanged={onMessageChange}
          onMessageSent={onMessageSent}
          customTitle={agentAvailability && isNotAvailable ? renderCustomChatTitle(agentAvailability) : null}
          customDescription={
            agentAvailability && isNotAvailable ? renderCustomChatDescription(agentAvailability, phones || []) : null
          }
          sitekey={captchaSpamSiteKey}
          showPushCheckbox={pushSubscribed}
          onFlocktoryCallback={this.callSystemPushNotificationPopup}
        />
      </Modal>
    );
  }

  private callSystemPushNotificationPopup = (isPushCheck: boolean) => {
    const { pushSubscribed } = this.props;

    sendSystemPushNotificationPopup(pushSubscribed, isPushCheck);
  };
}

function startChat(httpApi: IHttpApi) {
  return (params: IFirstMessage) => sendFirstMessage(httpApi, params);
}

function renderCustomChatTitle({ availableFrom, availableTo, vacationTo }: IAgentAvailabilitySchema) {
  if ((availableFrom && availableTo) || vacationTo) {
    return <TitleFormatter callFrom={availableFrom} callTo={availableTo} vacation={vacationTo} />;
  }

  return null;
}

function renderCustomChatDescription({ availableFrom, vacationTo }: IAgentAvailabilitySchema, phones: string[]) {
  return (
    <DescriptionFormatter
      callAt={vacationTo || availableFrom || ''}
      isVacation={!!vacationTo}
      additions={phones.map((p, i) => (
        <span key={p + i}>
          <a className={styles['phone']} href={`tel:${p}`}>
            {p}
          </a>
          {i !== phones.length - 1 ? ', ' : ''}
        </span>
      ))}
    />
  );
}

function mapStateToProps(state: IState): IPopupCallbackStoreProps {
  return {
    agentAvailability: state.offerData.agentAvailability,
    captchaSpamSiteKey: state.captchaSpamSiteKey,
    offer: state.offerData.offer,
    pushSubscribed: state.pushSubscribed,
    user: state.offerData.user,
  };
}

export const PopupStartChatContainer = connect<IPopupCallbackStoreProps, {}, IPopupCallbackOwnProps>(mapStateToProps)(
  PopupStartChatComponent,
);
